import { ValueObject } from '../../../shared/domain/value-object';

/** Value Object com os dados para enviar um e-mail de pedido/orçamento */
export class PedidoEmailSendValueObject extends ValueObject {
    id: number;
    to: string[];
    cc: string[];
    subject: string;
    message: string;

    constructor(id: number) {
        super();
        this.id = id;
        this.to = [];
        this.cc = [];
    }

    isValid(): boolean {
        // Sem pedido/orçamento
    	if (!this.id) {
            this.setPropError('id');
            this.setMessageError('O pedido/orçamento para enviar o e-mail não foi informado. Infome o pedido/orçamento para poder enviar o e-mail');
    		return false;
    	}

    	// Sem destinatário
    	if (!this.to || this.to.length === 0) {
            this.setPropError('to');
            this.setMessageError('Nenhum destinatário foi informado para enviar o e-mail. Adicione pelo menos um destinatário para poder enviar');
    		return false;
    	}

    	// Sem assunto
    	if (!this.subject || this.subject.trim().length === 0) {
            this.setPropError('subject');
            this.setMessageError('O assunto do envio do e-mail não foi informado. Informe o assunto para poder enviar o e-mail');
    		return false;
    	}

    	return true;
    }
}
